'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

// The page a visitor lands on when a listing has expired, an agency changed
// its address before the redirect existed, or a link was simply mistyped.
//
// It used to be English only - "404 - Page Not Found", "Return home" - on a
// site that is half French, and it used a plain <a>, which throws away the
// loaded application and fetches everything again. The language is taken from
// the path, because a not-found page is not given the route parameters.

export default function NotFound() {
  const pathname = usePathname();
  const isFr = pathname?.startsWith('/fr') ?? false;
  const home = isFr ? '/fr' : '/';

  return (
    <main id="main-content" className="min-h-screen flex flex-col items-center justify-center p-4 sm:p-8 text-center bg-black text-white">
      <title>{isFr ? '404 : page introuvable | Real Estate Channel' : '404: page not found | Real Estate Channel'}</title>
      <p className="text-sm font-mono uppercase tracking-widest text-neutral-400 mb-3">404</p>
      <h1 className="text-2xl sm:text-3xl font-bold mb-3">
        {isFr ? 'Cette page est introuvable' : 'We could not find that page'}
      </h1>
      <p className="text-sm text-neutral-400 max-w-md mb-8 leading-relaxed">
        {isFr
          ? "La page a peut-être été déplacée ou retirée (une annonce expirée, une agence qui a changé d'adresse), ou l'adresse comporte une erreur."
          : 'The page may have been moved or taken down (an expired listing, an agency that changed its address), or the address has a mistake in it.'}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          href={home}
          className="btn btn-primary btn-md"
        >
          {isFr ? "Retour à l'accueil" : 'Back to home'}
        </Link>
        <Link
          href={isFr ? '/fr/calculatrices' : '/calculators'}
          className="btn btn-secondary btn-md"
        >
          {isFr ? 'Les calculatrices' : 'The calculators'}
        </Link>
      </div>
    </main>
  );
}
